import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {Observable} from 'rxjs';
import {currentUserContributorExtsDetails, ITabTransactionsExts} from '@app/4dm1n/users-list/store/users-list.selector';
import {Column} from 'devextreme/ui/data_grid';

@Component({
  selector: 'app-ext-profils-tab',
  templateUrl: './ext-profils-tab.component.html',
  styleUrls: ['./ext-profils-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtProfilsTabComponent extends OnDestroyMixin implements OnInit {

  cExts$: Observable<ITabTransactionsExts> = this.store.select(currentUserContributorExtsDetails).pipe(untilComponentDestroyed(this));
  columns: Column[] = [
    {
      dataField: 'key_name',
      caption: 'Keyname',
      width: '80%',
      minWidth: 200,
    },
    {
      dataField: 'key_value',
      caption: 'Value',
    },
  ];

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {

    this.cExts$.pipe(untilComponentDestroyed(this)).subscribe((data) => {
      this.cdr.markForCheck();
    });

  }

}
